export const selectedFileItemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  height: 40,
  mt: 1,
};

export const selectedFileItemNameStyles = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '65%',
  fontWeight: 600,
};

export const switchBlockStyles = {
  p: 2,
  backgroundColor: '#F5F5F5',
  border: '1px dashed #999999',
  borderRadius: '8px',
};
